import { useEffect } from "react";
import { useRecoilState } from "recoil";
import queryStringAtom from "../recoils/useQueryString/queryStringAtom";
import reverseResultAtom from "../recoils/useReverseResult/reverseResultAtom";
import { getQueryString, getSearchCount } from "../services";
import { ISearchQueryRequest } from "../models/ISearchQueryRequest";
import { getLangSite } from "../ultils/translation.util";

export const useUpdateResultAndQueryString = (searchRequest: ISearchQueryRequest) => {
  const [, setQueryString] = useRecoilState(queryStringAtom);
  const [, setReverseResult] = useRecoilState(reverseResultAtom);
  const langSiteObj = getLangSite('en');

  useEffect(() => {
    if(Object.keys(searchRequest).length > 0){
      
      const getResult = async ()=>{
        const queryString = await getQueryString(searchRequest);
        setQueryString(queryString);
        const result = await getSearchCount({...searchRequest, lang: langSiteObj.lang, site: langSiteObj.site});
        setReverseResult(parseFloat(result).toLocaleString('en-US'));
      }
      getResult();
    }
  },[searchRequest]);
}
